package er.prateek.crossly.ui.share

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.unit.dp
import androidx.compose.foundation.text.KeyboardOptions
import crossly.shared.generated.resources.Res
import crossly.shared.generated.resources.common_cancel
import crossly.shared.generated.resources.common_ok
import crossly.shared.generated.resources.profile_name_hint
import crossly.shared.generated.resources.profile_name_skip
import crossly.shared.generated.resources.profile_name_title
import er.prateek.crossly.ui.components.GameButton
import er.prateek.crossly.ui.components.GameButtonSize
import er.prateek.crossly.ui.components.GameButtonStyle
import er.prateek.crossly.ui.theme.game
import org.jetbrains.compose.resources.stringResource

@Composable
fun NamePromptDialog(
    initialName: String,
    skipAllowed: Boolean,
    onSave: (String) -> Unit,
    onSkip: () -> Unit,
    onDismiss: () -> Unit,
) {
    val colors = MaterialTheme.game
    var value by remember(initialName) { mutableStateOf(initialName) }
    val canSave = value.trim().isNotEmpty()

    AlertDialog(
        onDismissRequest = onDismiss,
        containerColor = colors.card,
        shape = RoundedCornerShape(24.dp),
        title = {
            Text(stringResource(Res.string.profile_name_title), color = colors.ink)
        },
        text = {
            OutlinedTextField(
                value = value,
                onValueChange = { if (it.length <= 32) value = it },
                singleLine = true,
                placeholder = {
                    Text(stringResource(Res.string.profile_name_hint), color = colors.inkMuted)
                },
                keyboardOptions = KeyboardOptions(capitalization = KeyboardCapitalization.Words),
                modifier = Modifier.fillMaxWidth(),
                colors = OutlinedTextFieldDefaults.colors(
                    focusedTextColor = colors.ink,
                    unfocusedTextColor = colors.ink,
                    cursorColor = colors.accent,
                    focusedBorderColor = colors.accent,
                    unfocusedBorderColor = colors.cardBorder,
                    focusedContainerColor = colors.card,
                    unfocusedContainerColor = colors.card,
                ),
            )
        },
        confirmButton = {
            GameButton(
                text = stringResource(Res.string.common_ok),
                onClick = { if (canSave) onSave(value) },
                enabled = canSave,
                style = GameButtonStyle.PRIMARY,
                size = GameButtonSize.SMALL,
            )
        },
        dismissButton = {
            if (skipAllowed) {
                GameButton(
                    text = stringResource(Res.string.profile_name_skip),
                    onClick = onSkip,
                    style = GameButtonStyle.GHOST,
                    size = GameButtonSize.SMALL,
                )
            } else {
                GameButton(
                    text = stringResource(Res.string.common_cancel),
                    onClick = onDismiss,
                    style = GameButtonStyle.GHOST,
                    size = GameButtonSize.SMALL,
                )
            }
        },
    )
}
